import { ToggleGroup as BaseToggleGroup } from '@base-ui/react/toggle-group';
import type { ComponentProps } from 'react';
import { cx } from '../lib/styled.tsx';

export type ToggleGroupProps = ComponentProps<typeof BaseToggleGroup>;

/**
 * A segmented row of {@link Toggle}s sharing one value. Pass `multiple` to let
 * several stay pressed at once; arrow keys move between them either way.
 */
export function ToggleGroup({ className, ...props }: ToggleGroupProps) {
  return (
    <BaseToggleGroup
      className={cx(
        // `.seg`: a muted track, 4px of padding, 2px between segments, and the
        // segments themselves roomier than a toggle standing on its own.
        'inline-flex items-center gap-0.5 rounded-full bg-surface-muted p-1 *:px-6',
        'data-[orientation=vertical]:flex-col',
        className,
      )}
      {...props}
    />
  );
}
